export enum TransactionStatusesEnum {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
    REJECTED = 'REJECTED',
    CANCELLED = 'CANCELLED',
    PENDING_APPROVAL = 'PENDING_APPROVAL',
}
